import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import FormComponent from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent'
import {Grid} from 'react-bootstrap'
import StudentProfile from '../StudentProfileContainer/Component/StudentProfile'

const HSGPopupBackdropStyle = {
    top: 0,
    backgroundColor: '#000',
    opacity: 0.5
}

const HSGPopupBodyStyle = {

}

export default class HSGPopupComponent extends Component{

    getPopUpHeader = (headerText) => headerText ? <div className='hsg-card-header-label col-md-6 col-sm-6 col-xs-6'>{headerText}</div> : null
    getPopUpHeaderRight = (headerText) => headerText ? <div className='hsg-card-header-label col-md-6 col-sm-6 col-xs-6' style = {{textAlign: "right"}}>{headerText}</div> : null

    getForm = ({formDefs, onClose, onSubmit, onBlur}) => (
        <FormComponent
            onClose={onClose}
            onSubmit={onSubmit}
            formDefs={formDefs}
            onFieldBlur={onBlur}    
        />
    )



    getButtonActions = (e, onClick) => {
        e.preventDefault()
        onClick && onClick(e)
        this.props.onHide && this.props.onHide()
    } 

    getButtons = (buttons) => (
        <div className="text-right">
            {buttons.map((button,i)=>(
                <button 
                    key={i} 
                    className={button.className || 'hsg-btn'} 
                    onClick={e=>this.getButtonActions(e, button.onClick)}>
                    {button.text}
                </button>)
            )}
        </div>
    )

    getBody = (bodyText, buttons) => bodyText ? <div>
        {bodyText} 
        {buttons && buttons.length && this.getButtons(buttons)}
    </div> : null

    render = () => {
        const {props} = this
        const onBlur = props.onBlur ? props.onBlur : () => {}
        return (
            <Modal
                show={props.show}
                onHide={props.onHide}
                bsSize={'large'}
                backdropStyle={HSGPopupBackdropStyle}
            >
                <Modal.Header>
                    {this.getPopUpHeader(props.header)}
                    {this.getPopUpHeaderRight(props.headerRight)}
                </Modal.Header>
                <Modal.Body>
                    {props.isForm ? this.getForm({...props, onBlur}) : this.getBody(props.body, props.buttons)}
                </Modal.Body>
            </Modal>
        )
    }
}

HSGPopupComponent.defaultProps = {
    isForm: false
}

HSGPopupComponent.propTypes = {
    formDefs: PropTypes.object,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    header: PropTypes.string,
    headerRight: PropTypes.string,
    isForm: PropTypes.bool.isRequired,
    body: PropTypes.object,
    buttons: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string,
        onClick: PropTypes.func.isRequired,
        text: PropTypes.string.isRequired
    }))
}